import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.scoringInformation.loading;
export const selectErrorMessage = (state: RootState) =>
  state.scoringInformation.error;
export const scoringInformationResponse = (state: RootState) =>
  state.scoringInformation.scoringInformationResponse;
